import { MultiSelect as MantineMultiSelect } from '@mantine/core';
import React, { useCallback } from 'react';
import { useAppDispatch } from '@hooks/useDispatch';
import { setEditingCell } from '@store/Spreadsheet/editingSlice';
import { updateRow } from '@store/Spreadsheet/rowsSlice';
import { CommonCellProps } from '../Cell';
import classes from '../Cell.module.css';
import { IconSelector } from '@tabler/icons-react';
import { cellValueChanged } from '@store/Spreadsheet/cellChangesSlice';

export default function CellMultiSelect({ rowId, columnId, currentRow, isEditing, value = '', options = []}: CommonCellProps ) {
  const dispatch = useAppDispatch();
  const parsedValue = typeof value === 'string' ? value.split( ',' ).map( v => v.trim())
    .filter( Boolean ) : [];

  const commitEdit = useCallback(( newValues: string[]) => {
    if ( !currentRow ) return;
    const newValueString = newValues.join( ', ' );
    const newRowValues = { ...currentRow.values, [columnId]: newValueString };

    dispatch( updateRow({ id: rowId, changes: { values: newRowValues }}));
    dispatch( cellValueChanged({ rowId, columnId, oldValue: currentRow.values[columnId], newValue: newValueString }));
    // dispatch( setEditingCell( null ));
  }, [ dispatch, rowId, columnId, currentRow ]);

  const cancelEdit = useCallback(() => {
    dispatch( setEditingCell( null ));
  }, [dispatch]);

  const handleKeyDown = useCallback(( e: React.KeyboardEvent<HTMLInputElement> ) => {
    if ( !isEditing ) return;
    if ( e.key === 'Escape' ) {
      cancelEdit();
    }
  }, [ isEditing, cancelEdit ]);

  if ( !isEditing ) {
    return (
      <span className={classes.cellSelectValueWrapper}>
        <span className={classes.cellValue}>{value}</span>
        <IconSelector stroke={1} className={classes.cellSelectValueIcon} />
      </span>
    );
  }

  return (
    <MantineMultiSelect
      className={classes.cellSelectInput}
      value={parsedValue}
      onChange={( newValues ) => commitEdit( newValues )}
      onBlur={cancelEdit}
      onKeyDown={handleKeyDown}
      autoFocus
      data={options || []}
      checkIconPosition="right"
      variant="unstyled"
      styles={{
       root: { display: 'flex', alignItems: 'center', width: '100%' },
       wrapper: { height: '100%', minHeight: '0', display: 'flex', alignItems: 'center', width: '100%', padding: '1px' },
       input: { height: '100%', display: 'flex', alignItems: 'center', padding: '0px 7px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '13px',width: '100%' },
       dropdown: { boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.2)' },
       option: { fontSize: '13px' },
       pill:  {
        display: 'inline-flex',
        alignItems: 'center',
        // lineHeight: 1.4,
        userSelect: 'none',
        position: 'relative',
        backgroundColor: 'var(--mantine-color-gray-1)',
        borderRadius: '2px',
        fontSize: '11px'
      }
      }}
      comboboxProps={{ position: 'bottom', middlewares: { flip: false, shift: false }, offset: 0 }}
      dropdownOpened={true}
    />
  );
}

